webpackJsonp([244,242],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(69);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(113);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(1504);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(1503);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueCookies = __webpack_require__(994);
	
	var _vueCookies2 = _interopRequireDefault(_vueCookies);
	
	var _veeValidate = __webpack_require__(993);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	var _vueFullCalendar = __webpack_require__(995);
	
	var _vueFullCalendar2 = _interopRequireDefault(_vueFullCalendar);
	
	var _routes = __webpack_require__(813);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _vue2GoogleMaps = __webpack_require__(1511);
	
	var VueGoogleMaps = _interopRequireWildcard(_vue2GoogleMaps);
	
	var _vueInfiniteScroll = __webpack_require__(997);
	
	var _vueInfiniteScroll2 = _interopRequireDefault(_vueInfiniteScroll);
	
	var _main = __webpack_require__(595);
	
	var _Header = __webpack_require__(1007);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Sidebar = __webpack_require__(1008);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Aside = __webpack_require__(1004);
	
	var _Aside2 = _interopRequireDefault(_Aside);
	
	var _Footer = __webpack_require__(1006);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(889);
	
	_main.LicenseManager.setLicenseKey("Powata_Pte_Ltd_MultiApp_1Devs13_February_2019__MTU1MDAxNjAwMDAwMA==077653976455bd55dfc6fed55c94a879");
	
	var config = {
	  errorBagName: 'errors',
	  fieldsBagName: 'fields',
	  delay: 0,
	  locale: 'en',
	  dictionary: null,
	  strict: true
	};
	
	_vue2.default.use(VueGoogleMaps, {
	  load: {
	    key: 'AIzaSyCUq6Ws7jNr2LPMYlLCirNjQv0YMsHdfTY',
	    v: '3'
	  }
	});
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueCookies2.default);
	_vue2.default.use(_veeValidate2.default, config);
	_vue2.default.use(_vueFullCalendar2.default);
	_vue2.default.use(_vueInfiniteScroll2.default);
	
	var router = new _vueRouter2.default({
	  routes: _routes2.default,
	  linkActiveClass: 'active',
	  history: true
	});
	
	router.beforeEach(function (to, from, next) {
	  window.scrollTo(0, 0);
	
	  var cookies = _vueCookies2.default;
	
	  if (cookies.isKey('om_session')) {
	    var dateNow = parseInt(new Date().getTime() / 1000);
	    if (dateNow >= cookies.get('om_session_last') || !cookies.isKey('om_session_last')) {
	      _vue2.default.http.post(("https://annam.powata.com/api") + '/user/refresh?token=' + cookies.get('om_session')).then(function (response) {
	        cookies.remove('om_session');
	        cookies.remove('om_session_info');
	        cookies.remove('om_session_company');
	        cookies.remove('om_session_permissions');
	        cookies.remove('om_session_roles');
	
	        cookies.set('om_session', response.body.token, '30d');
	        var generalInfo = {
	          'id': response.body.id,
	          'first_name': response.body.first_name,
	          'last_name': response.body.last_name,
	          'email': response.body.email,
	          'current_contract_id': response.body.current_contract_id,
	          'user_level': response.body.user_level
	        };
	        cookies.set('om_session_info', (0, _stringify2.default)(generalInfo), '30d');
	        cookies.set('om_session_company', (0, _stringify2.default)(response.body.company), '30d');
	        cookies.set('om_session_permissions', response.body.permissions, '30d');
	        cookies.set('om_session_roles', (0, _stringify2.default)(response.body.roles), '30d');
	        cookies.set('om_session_user_login_count', (0, _stringify2.default)(response.body.login_count), '30d');
	
	        var date = new Date();
	        var nextSessionCheck = new Date(date.setMinutes(date.getMinutes() + 50)).getTime() / 1000;
	        cookies.set('om_session_last', parseInt(nextSessionCheck), '30d');
	      }, function (response) {});
	    }
	  }
	  cookies.set('om_session_previous_page', from.path.substring(1), '30d');
	  if (to.path !== '/login' && to.path !== '/register' && to.name !== '/signup' && to.name !== '/reset' && to.path !== '/forgot' && to.path !== '/user/oauth/check') {
	    if (cookies.get('om_session') === null) {
	      next({ path: '/login' });
	    } else {
	      _vue2.default.http.get(("https://annam.powata.com/api") + '/check_user_token?token=' + cookies.get('om_session')).then(function (response) {
	        next();
	      }, function (response) {
	        if (response === 'valid_token') {
	          next();
	        } else {
	          cookies.remove('om_session');
	          next({ path: '/login' });
	        }
	      });
	    }
	  } else {
	    if (cookies.get('om_session') !== null) {
	      next({ path: '/retailer-execution?page=1' });
	    } else {
	      next();
	    }
	  }
	});
	
	new _vue2.default({
	  components: {
	    'app-header': _Header2.default,
	    'app-sidebar': _Sidebar2.default,
	    'app-aside': _Aside2.default,
	    'app-footer': _Footer2.default
	  },
	  router: router,
	  methods: {
	    isAdminPage: function isAdminPage(path, name) {
	      var publicComponents = ['/login', '/register', '/signup', '/welcome', '/reset', '/forgot', '/user/oauth/check'];
	      return publicComponents.indexOf(path) >= 0 || publicComponents.indexOf(name) >= 0;
	    }
	  }
	}).$mount('#app');

/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(996);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	__webpack_require__(944);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: {
	        events: {
	            default: function _default() {
	                return [];
	            }
	        },
	
	        eventSources: {
	            default: function _default() {
	                return [];
	            }
	        },
	
	        editable: {
	            default: function _default() {
	                return true;
	            }
	        },
	
	        selectable: {
	            default: function _default() {
	                return true;
	            }
	        },
	
	        selectHelper: {
	            default: function _default() {
	                return true;
	            }
	        },
	
	        header: {
	            default: function _default() {
	                return {
	                    left: 'prev,next today',
	                    center: 'title',
	                    right: 'month,agendaWeek,agendaDay'
	                };
	            }
	        },
	
	        defaultView: {
	            default: function _default() {
	                return 'agendaWeek';
	            }
	        },
	
	        sync: {
	            default: function _default() {
	                return false;
	            }
	        },
	
	        config: {
	            type: Object,
	            default: function _default() {
	                return {};
	            }
	        }
	    },
	
	    computed: {
	        defaultConfig: function defaultConfig() {
	            var self = this;
	            return {
	                header: this.header,
	                defaultView: this.defaultView,
	                editable: this.editable,
	                selectable: this.selectable,
	                selectHelper: this.selectHelper,
	                aspectRatio: 2,
	                timeFormat: 'HH:mm',
	                events: this.events,
	                eventSources: this.eventSources,
	
	                eventRender: function eventRender() {
	                    if (this.sync) {
	                        self.events = cal.fullCalendar('clientEvents');
	                    }
	
	                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	                        args[_key] = arguments[_key];
	                    }
	
	                    self.$emit.apply(self, ['event-render'].concat(args));
	                },
	                eventDestroy: function eventDestroy(event) {
	                    if (this.sync) {
	                        self.events = cal.fullCalendar('clientEvents');
	                    }
	                },
	                eventClick: function eventClick() {
	                    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	                        args[_key2] = arguments[_key2];
	                    }
	
	                    self.$emit.apply(self, ['event-selected'].concat(args));
	                },
	                eventDrop: function eventDrop() {
	                    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	                        args[_key3] = arguments[_key3];
	                    }
	
	                    self.$emit.apply(self, ['event-drop'].concat(args));
	                },
	                eventResize: function eventResize() {
	                    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	                        args[_key4] = arguments[_key4];
	                    }
	
	                    self.$emit.apply(self, ['event-resize'].concat(args));
	                },
	                dayClick: function dayClick() {
	                    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	                        args[_key5] = arguments[_key5];
	                    }
	
	                    self.$emit.apply(self, ['day-click'].concat(args));
	                },
	                select: function select(start, end, jsEvent) {
	                    self.$emit('event-created', {
	                        start: start,
	                        end: end,
	                        allDay: !start.hasTime() && !end.hasTime()
	                    });
	                }
	            };
	        }
	    },
	
	    mounted: function mounted() {
	        var _this = this;
	
	        var cal = $(this.$el),
	            self = this;
	
	        this.$on('remove-event', function (event) {
	            if (event && event.hasOwnProperty('id')) {
	                $(_this.$el).fullCalendar('removeEvents', event.id);
	            } else {
	                $(_this.$el).fullCalendar('removeEvents', event);
	            }
	        });
	
	        this.$on('rerender-events', function () {
	            $(_this.$el).fullCalendar('rerenderEvents');
	        });
	
	        this.$on('refetch-events', function () {
	            $(_this.$el).fullCalendar('refetchEvents');
	        });
	
	        this.$on('render-event', function (event) {
	            $(_this.$el).fullCalendar('renderEvent', event);
	        });
	
	        this.$on('reload-events', function () {
	            $(_this.$el).fullCalendar('removeEvents');
	            $(_this.$el).fullCalendar('addEventSource', _this.events);
	        });
	
	        this.$on('rebuild-sources', function () {
	            $(_this.$el).fullCalendar('removeEvents');
	            _this.eventSources.map(function (event) {
	                $(_this.$el).fullCalendar('addEventSource', event);
	            });
	        });
	
	        cal.fullCalendar((0, _lodash2.default)(this.config, this.defaultConfig));
	    },
	
	
	    methods: {
	        fireMethod: function fireMethod() {
	            var _$;
	
	            (_$ = $(this.$el)).fullCalendar.apply(_$, arguments);
	        }
	    },
	
	    watch: {
	        events: {
	            deep: true,
	            handler: function handler(val) {
	                $(this.$el).fullCalendar('removeEvents');
	                $(this.$el).fullCalendar('addEventSource', this.events);
	            }
	        },
	        eventSources: {
	            deep: true,
	            handler: function handler(val) {
	                this.$emit('rebuild-sources');
	            }
	        }
	    },
	
	    beforeDestroy: function beforeDestroy() {
	        this.$off('remove-event');
	        this.$off('rerender-events');
	        this.$off('refetch-events');
	        this.$off('render-event');
	        this.$off('reload-events');
	        this.$off('rebuild-sources');
	    }
	};

/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(119);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      permissions: this.$cookies.isKey('om_session_permissions') ? this.$cookies.get('om_session_permissions').split(',') : [],
	      logo: '',
	      company_name: 'The Company Name',
	      roles: this.$cookies.isKey('om_session_roles') ? JSON.parse(this.$cookies.get('om_session_roles')) : [],
	      is_manager: false,
	      is_merchandiser: false,
	      is_client: false,
	      is_promoter: false,
	      company_plan: '',
	      is_master: false
	    };
	  },
	  created: function created() {
	    var company = this.$cookies.isKey('om_session_company') ? JSON.parse(this.$cookies.get('om_session_company')) : [];
	    if ((0, _keys2.default)(company).length) {
	      this.company_name = company.name;
	      this.logo = company.logo;
	      this.company_plan = company ? parseInt(company.plan_id) : null;
	    }
	    var vue = this;
	    _lodash2.default.each(this.roles, function (item) {
	      if (item.name === 'manager') {
	        vue.is_manager = true;
	      }
	      if (item.name === 'supervisor') {
	        vue.is_manager = true;
	        vue.is_master = true;
	      }
	      if (item.name === 'merchandiser') {
	        vue.is_merchandiser = true;
	      }
	      if (item.name === 'client') {
	        vue.is_client = true;
	      }
	      if (item.name === 'promoter') {
	        vue.is_promoter = true;
	      }
	      if (item.name === 'Sales Manager' || item.name === 'Sales and Data Controller' || item.name === 'Data Admin') {
	        vue.is_master = true;
	      }
	    });
	    console.log(this.is_manager);
	  },
	
	  methods: {
	    logout: function logout(event) {
	      this.$http.post(("https://annam.powata.com/api") + '/user/logout?token=' + this.$cookies.get('om_session')).then(function (response) {}, function (response) {});
	
	      this.$cookies.remove('om_session');
	      this.$cookies.remove('om_session_info');
	      this.$cookies.remove('om_session_company');
	      this.$cookies.remove('om_session_permissions');
	      this.$cookies.remove('om_session_roles');
	      this.$cookies.remove('om_session_last');
	      this.$cookies.remove('current_menu');
	      this.$router.go('/login');
	    },
	    is_active_menu: function is_active_menu(menu) {
	      if (this.$cookies.get('current_menu') == menu) {
	        return true;
	      } else {
	        return false;
	      }
	    }
	  }
	};

/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(119);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _defineProperty2 = __webpack_require__(221);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _sweetalert = __webpack_require__(12);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _lodash = __webpack_require__(19);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    var _ref;
	
	    return _ref = {
	      permissions: this.$cookies.isKey('om_session_permissions') ? this.$cookies.get('om_session_permissions').split(',') : [],
	      master_data_paths: ['retailers', 'clients', 'store-model', 'products', 'product-categories', 'product-brands', 'product-mapping-codes', 'product-packings', 'price-lists', 'merchandisers', 'promoter-rosters', 'promoters'],
	      features: this.$cookies.isKey('om_session_features') && this.$cookies.get('om_session_features') !== 'undefined' ? JSON.parse(this.$cookies.get('om_session_features')) : [],
	      retailers_paths: ['/retailers', '/retailers/add', 'edit-retailers'],
	      client_paths: ['/clients', '/clients/add', 'edit-client'],
	      store_model_paths: ['/store-model', '/store-model/add', 'edit-store-model'],
	      visit_paths: ['/visits', '/visits/add', 'edit-visit'],
	      product_paths: ['/products', '/products/add', 'edit-product'],
	      productpacking_paths: ['/product-packings', '/product-packings/add', 'edit-productpacking'],
	      productcategory_paths: ['/product-categories', '/product-categories/add', 'edit-productcategory'],
	      productbrand_paths: ['/product-brands', '/product-brands/add', 'edit-product-brand'],
	      productmapping_paths: ['/product-mapping-codes', '/product-mapping-codes/add', 'edit-product-mapping-code'],
	      pricelists_paths: ['/price-lists', '/price-lists/add', 'edit-product-price-list'],
	      merchandiser_paths: ['/merchandisers', '/merchandisers/add', 'edit-merchandiser'],
	      promoter_roster_path: ['/promoter-rosters', '/promoter-roster/add', 'promoter-roster/edit'],
	      promoter_path: ['/promoters', '/promoter/add', '/promoter/edit'],
	      planogram_path: ['/planograms', '/planograms/add', '/planograms/edit'],
	      settings_path: ['settings', 'users', 'roles'],
	      promoters_path: ['promoters_sales'],
	      clientusers_path: ['clientusers', 'clientusers/edit'],
	      assignsupervisor_path: ['assign-supervisor', 'assign-supervisor/add'],
	      userinfo: this.$cookies.isKey('om_session_info') ? this.$cookies.get('om_session_info') : [],
	      visit: ['visits', 'visits/calendar'],
	      actions_url: ['visits', 'visit-calendar', 'promoter-rosters', 'promoter-calendar'],
	      locations_url: ['locations', 'location-map'],
	      reports_url: ['visit-report2', 'photo-gallery-report', 'store-audit-report', 'task-report', 'historical-taskreport', 'no-visit-location-report', 'uncompleted-store-visits', 'master-visit-report', 'promoter-roster-report', 'non-clocked-employee-reports', 'salesreport', 'commission-report', 'customers', 'stock-take-reports', 'order-form-report', 'planogram-visit-reports', 'oos-report', 'stock-take-management-reports', 'stock-request-management-reports', 'stock-receipt-management-reports', 'stock-transfer-management-reports', 'stock-receipt-erp-management-reports', 'discrepancy-report', 'sampling-reports'],
	      sales_settings_url: ['sales-target-location', 'sales-target-promoter'],
	      manage_users_url: ['users', 'clientusers', 'assign-supervisor'],
	      location_settings_url: ['clients', 'retailers', 'planograms'],
	      project_settings_url: ['product-packings', 'product-categories', 'product-brands', 'products', 'store-model', 'price-lists', 'product-mapping-codes'],
	      active_actions: false,
	      active_locations: false,
	      active_reports: false,
	      active_sales_settings: false,
	      active_getting_started: false,
	      active_manage_users: false,
	      active_product_settings: false,
	      roles: this.$cookies.isKey('om_session_roles') ? JSON.parse(this.$cookies.get('om_session_roles')) : [],
	      is_manager: false,
	      is_merchandiser: false,
	      is_client: false,
	      is_promoter: false,
	      current_top_menu: '',
	      active_action: false,
	      active_sampling_report: ['sampling-reports?'],
	      active_visit: false,
	      active_visit_report: false,
	      active_promoters_report: false,
	      active_stock_movement: false,
	      active_location_settings: false
	    }, (0, _defineProperty3.default)(_ref, 'active_product_settings', false), (0, _defineProperty3.default)(_ref, 'active_sales_settings', false), (0, _defineProperty3.default)(_ref, 'active_company_settings', false), (0, _defineProperty3.default)(_ref, 'company_settings', false), (0, _defineProperty3.default)(_ref, 'active_getting_stated', false), (0, _defineProperty3.default)(_ref, 'getting_started_settings', []), (0, _defineProperty3.default)(_ref, 'plan', ''), (0, _defineProperty3.default)(_ref, 'is_master', false), (0, _defineProperty3.default)(_ref, 'is_supervisor', false), (0, _defineProperty3.default)(_ref, 'sampling', 0), _ref;
	  },
	  beforeCreate: function beforeCreate() {
	    this.permissions = this.$cookies.isKey('om_session_permissions') ? this.$cookies.get('om_session_permissions').split(',') : [];
	  },
	
	  mounted: function mounted() {},
	  created: function created() {
	    var vue = this;
	    _lodash2.default.each(this.roles, function (item) {
	      if (item.name === 'manager') {
	        vue.is_manager = true;
	      }
	      if (item.name === 'supervisor') {
	        vue.is_manager = true;
	      }
	      if (item.name === 'merchandiser') {
	        vue.is_merchandiser = true;
	      }
	      if (item.name === 'client') {
	        vue.is_client = true;
	      }
	      if (item.name === 'promoter') {
	        vue.is_promoter = true;
	      }
	      if (item.name === 'Sales Manager' || item.name === 'Sales and Data Controller' || item.name === 'Data Admin' || item.name === 'manager' || item.name === 'supervisor') {
	        vue.is_master = true;
	      }
	      if (item.name === 'supervisor') {
	        vue.is_supervisor = true;
	      }
	    });
	
	    var company = this.$cookies.isKey('om_session_company') ? JSON.parse(this.$cookies.get('om_session_company')) : [];
	    this.permissions = this.$cookies.isKey('om_session_permissions') ? this.$cookies.get('om_session_permissions').split(',') : [];
	    if ((0, _keys2.default)(company).length) {
	      this.plan = company ? parseInt(company.plan_id) : null;
	      this.sampling = company.sampling;
	    }
	  },
	
	  watch: {
	    '$route': function $route(to, from) {
	      var url = this.$route.path.split('/');
	      if (url[1] == 'profile') {
	        this.current_top_menu = 'user profile';
	      } else if (url[1] == 'settings') {
	        this.current_top_menu = 'settings';
	      } else {
	        this.current_top_menu = this.$cookies.get('current_menu');
	      }
	      if (this.$cookies.get('om_session_previous_page') === 'welcome') {
	        window.location.reload();
	      }
	      var path = this.$route.path;
	      if (url[1] !== 'login' && url[1] !== 'register' && url[1] !== 'signup' && url[1] !== 'welcome' && url[1] !== 'dashboard' && url[1] !== 'reset' && url[1] !== 'forgot' && path !== '//user/oauth/check') {
	        this.permissions = this.$cookies.isKey('om_session_permissions') ? this.$cookies.get('om_session_permissions').split(',') : [];
	        if (this.permissions.length === 0) {
	          this.$cookies.remove('om_session');
	          this.$cookies.remove('om_session_info');
	          this.$cookies.remove('om_session_company');
	          this.$cookies.remove('om_session_permissions');
	          this.$cookies.remove('om_session_roles');
	          this.$cookies.remove('om_session_last');
	          this.$cookies.remove('current_menu');
	          (0, _sweetalert2.default)({
	            title: 'Session Expired !',
	            text: '',
	            type: 'warning',
	            showCancelButton: false,
	            allowOutsideClick: false
	          }).then(function () {
	            this.$router.push('/login');
	          }.bind(this), function (dismiss) {
	            if (dismiss === 'cancel') {
	              this.$router.push('/login');
	            }
	          }.bind(this));
	        }
	      }
	
	      this.active_locations = false;
	      this.active_actions = false;
	      this.active_reports = false;
	
	      if (this.actions_url.includes(url[1])) {
	        this.active_actions = true;
	      } else if (this.locations_url.includes(url[1])) {
	        this.active_locations = true;
	      } else if (this.reports_url.includes(url[1])) {
	        this.active_reports = true;
	      } else if (this.sales_settings_url.includes(url[1])) {
	        this.active_sales_settings = true;
	      } else if (this.manage_users_url.includes(url[1])) {
	        this.active_manage_users = true;
	      } else if (this.location_settings_url.includes(url[1])) {
	        this.active_location_settings = true;
	      } else if (this.project_settings_url.includes(url[1])) {
	        this.active_product_settings = true;
	      } else {}
	
	      if (this.actions_url.includes(url[1])) {
	        this.active_actions = true;
	      }
	    }
	  },
	  methods: {
	    isActiveMenuGroup: function isActiveMenuGroup() {
	      var menuitems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      for (var i in menuitems) {
	        var pattern = new RegExp(menuitems[i]);
	        if (pattern.test(this.$route.path)) {
	          return true;
	        }
	      }
	    },
	    isActiveMenu: function isActiveMenu(path) {
	      var pattern = new RegExp(path);
	      return pattern.test(this.$route.path);
	    },
	
	    logout: function logout(event) {
	      this.$http.post(("https://annam.powata.com/api") + '/user/logout?token=' + this.$cookies.get('om_session')).then(function (response) {}, function (response) {});
	
	      this.$cookies.remove('om_session');
	      this.$cookies.remove('om_session_info');
	      this.$cookies.remove('om_session_company');
	      this.$cookies.remove('om_session_permissions');
	      this.$cookies.remove('om_session_roles');
	      this.$cookies.remove('om_session_last');
	      this.$router.go('/login');
	    }
	  }
	};

/***/ }),

/***/ 813:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Dashboard = function Dashboard(resolve) {
	  return __webpack_require__.e/* require */(18, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1011)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var NotFound = function NotFound(resolve) {
	  return __webpack_require__.e/* require */(241, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1009)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Login = function Login(resolve) {
	  return __webpack_require__.e/* require */(122, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1013)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	module.exports = [{ path: '/register', component: function component(resolve) {
	    return __webpack_require__.e/* require */(105, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1014)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  } }, { path: '/login', component: Login }, { name: '/user/oauth/check', path: '/user/oauth/check', component: function component(resolve) {
	    return __webpack_require__.e/* require */(186, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1010)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  } }, { path: '/forgot', component: function component(resolve) {
	    return __webpack_require__.e/* require */(182, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1012)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  } }, { name: '/reset', path: '/reset/:id', component: function component(resolve) {
	    return __webpack_require__.e/* require */(181, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1015)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  } }, {
	  name: '/signup',
	  path: '/signup/:id',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(180, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1016)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, { path: '/', redirect: '/dashboard' }, { path: '/dashboard', component: Dashboard }, {
	  path: '/products',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(212, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1122)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(75, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1121)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(45, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1119)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id',
	    name: 'edit-product',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(44, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1120)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/clients',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(235, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1040)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(91, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1039)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(23, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1037)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-client',
	    path: 'edit/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(22, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1038)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/product-categories',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(211, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1126)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(53, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1125)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(154, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1123)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id',
	    name: 'edit-productcategory',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(153, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1124)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/product-packings',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(210, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1130)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(74, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1129)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(177, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1127)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id',
	    name: 'edit-productpacking',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(176, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1128)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/product-brands',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(215, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1109)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(77, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1108)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(158, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1106)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id',
	    name: 'edit-product-brand',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(157, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1107)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/product-mapping-codes',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(214, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1113)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(117, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1114)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(156, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1110)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id',
	    name: 'edit-product-mapping-code',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(155, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1111)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'filter',
	    name: 'filter-product-mapping-code',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(87, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1112)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/product-price-lists',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(213, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1118)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(76, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1117)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(40, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1115)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id',
	    name: 'edit-product-price-list',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(39, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1116)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/promo-price-lists',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(209, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1135)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(124, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1134)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(34, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1132)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id',
	    name: 'edit-promo-price-list',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(30, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1133)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/visits',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(580)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(46, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1246)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1241)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'bulk-add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1242)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id',
	    name: 'edit-visit',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1245)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'recurring-visit-add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1243)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/visit-calendar',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(580)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(50, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1244)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/retailers',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(203, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1160)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(72, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1159)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(25, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1157)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id',
	    name: 'edit-retailers',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(24, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1158)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/locations',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(227, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1065)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(54, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1064)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-location',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(21, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1062)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-location',
	    path: 'edit/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(20, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1063)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/location-map',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(229, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1058)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(120, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1057)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/tasks',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(192, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1220)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(86, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1219)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(27, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1217)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id',
	    name: 'edit-task',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(26, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1218)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/settings',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(578)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(63, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1174)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add-region',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(146, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1181)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-region',
	    path: 'edit-region/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(145, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1182)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add-location-grade',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(150, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1177)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add-department',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(172, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1175)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-department',
	    path: 'edit-department/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(151, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1176)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-location-grade',
	    path: 'edit-location-grade/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(149, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1178)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add-location-type',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(148, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1179)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-location-type',
	    path: 'edit-location-type/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(147, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1180)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add-store-category',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(144, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1183)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-store-category',
	    path: 'edit-store-category/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(143, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1184)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/profile',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(3/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(578)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(134, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1131)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/store-model',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(194, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1211)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(64, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1210)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-store-model',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(33, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1208)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-store-model',
	    path: 'edit/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(29, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1209)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/assign-retailers-price-lists',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(239, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1027)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(129, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1026)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-retailers-price',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(101, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1022)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-retailers-price',
	    path: 'edit',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(168, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1024)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-retailers-promo',
	    path: 'editpromo',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(167, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1025)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-retailers-promo',
	    path: 'addpromo',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(100, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1023)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/store-model-locations',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(193, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1214)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(123, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1213)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-store-model-locations',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(95, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1212)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/client-retailers',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(236, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1036)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(126, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1035)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-client-retailer',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(97, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1034)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/client-location',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(237, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1033)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(127, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1032)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-client-location',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(98, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1031)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/merchandisers',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(223, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1078)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(79, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1077)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-merchandiser',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(178, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1075)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-merchandiser',
	    path: 'edit/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(161, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1076)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/users',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(190, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1228)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(85, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1226)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-user',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(171, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1224)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-user',
	    path: 'edit',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(131, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1225)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'invite-user',
	    path: 'invite',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(170, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1227)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/roles',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(202, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1164)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(185, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1163)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-role',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(174, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1161)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-role',
	    path: 'edit',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(173, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1162)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/price-lists',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(216, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1105)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(65, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1104)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(41, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1102)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id',
	    name: 'edit-price-list',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(31, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1103)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/visit-report',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(187, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1240)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(66, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1239)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(36, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1237)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id',
	    name: 'edit-visit-report',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(35, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1238)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/visit-report2',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(188, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1236)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(32, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1235)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(38, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1233)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id',
	    name: 'edit-visit-report2',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(37, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1234)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/retailer-reports',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(204, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1155)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(47, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1154)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'view/:id/:taskid',
	    name: 'view-retailer-report',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(93, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1156)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id/:taskid',
	    name: 'edit-retailer-report',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(94, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1153)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/photo-gallery-report',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(219, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1088)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(60, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1087)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'photos',
	    path: 'photos',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(59, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1089)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/stock-take-photo-reports',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(198, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1189)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(58, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1188)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'photos2',
	    path: 'photos',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(57, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1190)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/machine-learning-pictures',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(225, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1071)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1070)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'photos2',
	    path: 'photos',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(61, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1072)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/stock-take-reports',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(196, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1204)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(110, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1200)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'view/:id',
	    name: 'view-stock-take-report',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1205)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'order-form/:id',
	    name: 'view-order-form',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(184, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1201)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/planogram-visit-reports',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(576)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(119, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1094)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'view/:id',
	    name: 'view-planogram-report',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1097)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'view-smart/:id',
	    name: 'view-smart-planogram-report',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1096)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'oos/:id',
	    name: 'view-oos-report',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(118, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1095)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/photo-gallery-reports',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(5/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(576)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(78, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1090)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/uncompleted-store-visits',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(191, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1222)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(109, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1221)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'view/:id',
	    name: 'view-uncompleted-store-visits',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(183, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1223)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/announcements',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(240, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1020)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    name: 'all',
	    path: 'all',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(169, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1019)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-announcement',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(104, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1018)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'update-announcement',
	    path: 'update/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(103, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1021)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/promoter-rosters',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(577)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(51, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1142)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(82, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1139)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-bulk',
	    path: 'add-bulk',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(83, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1138)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-rosters',
	    path: 'edit/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(81, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1141)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/promoter-calendar',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(4/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(577)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(52, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1140)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/non-clocked-employee-reports',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(222, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1080)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(92, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1079)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/promoters',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(207, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1146)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(73, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1145)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-promoters',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(175, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1143)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-promoter',
	    path: 'edit/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(152, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1144)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/salesreport',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(200, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1170)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(14, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1169)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-salesreport',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(16, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1167)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-salesreport',
	    path: 'edit/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(15, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1168)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'view-salesreport',
	    path: 'view/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(19, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1171)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/stock-take-management-reports',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(192)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(112, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1191)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'view-stock-take',
	    path: 'view-stock-take/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(68, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1196)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/stock-receipt-management-reports',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(192)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(114, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1186)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'view-stock-receipt',
	    path: 'view-stock-receipt/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(70, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1194)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/stock-request-management-reports',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(192)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(113, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1187)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'view-stock-request',
	    path: 'view-stock-request/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(69, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1195)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/stock-transfer-management-reports',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(192)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(111, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1192)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'view-stock-transfer',
	    path: 'view-stock-transfer/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(67, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1197)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/oos-report',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(221, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1083)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(160, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1082)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'filtered',
	    path: 'filtered',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(107, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1081)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/order-form-report',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(220, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1086)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(159, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1085)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'filtered2',
	    path: 'filtered',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(106, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1084)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/sales-target-location',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(226, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1069)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(49, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1068)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'sales-target-location-edit',
	    path: 'edit/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(137, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1067)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'sales-target-location-add',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(138, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1066)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/sales-target-promoter',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(206, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1150)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(48, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1149)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'sales-target-promoter-edit',
	    path: 'edit/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(132, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1148)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'sales-target-promoter-add',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(133, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1147)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	
	  }]
	}, { path: '/welcome', component: function component(resolve) {
	    return __webpack_require__.e/* require */(121, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1017)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  } }, {
	  path: '/company',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(232, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1050)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(90, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1049)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-company',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(140, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1047)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-company',
	    path: 'edit/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(139, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1048)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/usersadmin',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(189, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1232)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(84, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1231)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'admin-add-user',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(141, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1229)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'admin-edit-user',
	    path: 'edit/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(130, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1230)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/clientusers',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(234, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1044)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(80, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1043)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-clientusers',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(179, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1041)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-clientusers',
	    path: 'edit/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(166, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1042)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/store-audit-report',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(195, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1207)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(142, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1206)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/master-visit-report',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(224, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1074)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(162, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1073)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/promoter-roster-report',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(208, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1137)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(28, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1136)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/planograms',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(217, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1101)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(88, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1100)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(136, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1098)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-planogram',
	    path: 'edit/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(135, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1099)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/planogram-location',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(218, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1093)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(125, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1092)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-planogram-location',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(96, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1091)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/no-visit-location-report',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(228, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1061)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(55, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1060)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'filtered3',
	    path: 'filtered',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(108, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1059)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/commission-report',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(233, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1046)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(56, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1045)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/task-report',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(579)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(62, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1216)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/historical-taskreport',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(2/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(579)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(102, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1215)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/customers',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(231, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1054)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(89, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1053)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-customer',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(165, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1051)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-customer',
	    path: 'edit/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(164, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1052)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/discrepancy-report',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(230, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1056)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(163, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1055)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/stock-receipt-erp-management-reports',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(192)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(115, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1185)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'view-stock-receipt-erp',
	    path: 'view-stock-receipt-erp/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(71, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1193)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/retailer-execution',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(205, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1152)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(43, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1151)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/sales-dashboard',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(201, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1166)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(17, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1165)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/stock-management-dashboard',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(197, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1199)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(42, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1198)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/sampling-reports',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(199, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1173)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(116, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1172)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/assign-supervisor',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(238, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1030)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(128, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1029)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-assign-supervisor',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(99, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(1028)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, { path: '*', component: NotFound }];

/***/ }),

/***/ 889:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 898:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 915:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 935:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 986:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 458,
		"./af.js": 458,
		"./ar": 465,
		"./ar-dz": 459,
		"./ar-dz.js": 459,
		"./ar-kw": 460,
		"./ar-kw.js": 460,
		"./ar-ly": 461,
		"./ar-ly.js": 461,
		"./ar-ma": 462,
		"./ar-ma.js": 462,
		"./ar-sa": 463,
		"./ar-sa.js": 463,
		"./ar-tn": 464,
		"./ar-tn.js": 464,
		"./ar.js": 465,
		"./az": 466,
		"./az.js": 466,
		"./be": 467,
		"./be.js": 467,
		"./bg": 468,
		"./bg.js": 468,
		"./bm": 469,
		"./bm.js": 469,
		"./bn": 470,
		"./bn.js": 470,
		"./bo": 471,
		"./bo.js": 471,
		"./br": 472,
		"./br.js": 472,
		"./bs": 473,
		"./bs.js": 473,
		"./ca": 474,
		"./ca.js": 474,
		"./cs": 475,
		"./cs.js": 475,
		"./cv": 476,
		"./cv.js": 476,
		"./cy": 477,
		"./cy.js": 477,
		"./da": 478,
		"./da.js": 478,
		"./de": 481,
		"./de-at": 479,
		"./de-at.js": 479,
		"./de-ch": 480,
		"./de-ch.js": 480,
		"./de.js": 481,
		"./dv": 482,
		"./dv.js": 482,
		"./el": 483,
		"./el.js": 483,
		"./en-au": 484,
		"./en-au.js": 484,
		"./en-ca": 485,
		"./en-ca.js": 485,
		"./en-gb": 486,
		"./en-gb.js": 486,
		"./en-ie": 487,
		"./en-ie.js": 487,
		"./en-nz": 488,
		"./en-nz.js": 488,
		"./eo": 489,
		"./eo.js": 489,
		"./es": 492,
		"./es-do": 490,
		"./es-do.js": 490,
		"./es-us": 491,
		"./es-us.js": 491,
		"./es.js": 492,
		"./et": 493,
		"./et.js": 493,
		"./eu": 494,
		"./eu.js": 494,
		"./fa": 495,
		"./fa.js": 495,
		"./fi": 496,
		"./fi.js": 496,
		"./fo": 497,
		"./fo.js": 497,
		"./fr": 500,
		"./fr-ca": 498,
		"./fr-ca.js": 498,
		"./fr-ch": 499,
		"./fr-ch.js": 499,
		"./fr.js": 500,
		"./fy": 501,
		"./fy.js": 501,
		"./gd": 502,
		"./gd.js": 502,
		"./gl": 503,
		"./gl.js": 503,
		"./gom-latn": 504,
		"./gom-latn.js": 504,
		"./gu": 505,
		"./gu.js": 505,
		"./he": 506,
		"./he.js": 506,
		"./hi": 507,
		"./hi.js": 507,
		"./hr": 508,
		"./hr.js": 508,
		"./hu": 509,
		"./hu.js": 509,
		"./hy-am": 510,
		"./hy-am.js": 510,
		"./id": 511,
		"./id.js": 511,
		"./is": 512,
		"./is.js": 512,
		"./it": 513,
		"./it.js": 513,
		"./ja": 514,
		"./ja.js": 514,
		"./jv": 515,
		"./jv.js": 515,
		"./ka": 516,
		"./ka.js": 516,
		"./kk": 517,
		"./kk.js": 517,
		"./km": 518,
		"./km.js": 518,
		"./kn": 519,
		"./kn.js": 519,
		"./ko": 520,
		"./ko.js": 520,
		"./ky": 521,
		"./ky.js": 521,
		"./lb": 522,
		"./lb.js": 522,
		"./lo": 523,
		"./lo.js": 523,
		"./lt": 524,
		"./lt.js": 524,
		"./lv": 525,
		"./lv.js": 525,
		"./me": 526,
		"./me.js": 526,
		"./mi": 527,
		"./mi.js": 527,
		"./mk": 528,
		"./mk.js": 528,
		"./ml": 529,
		"./ml.js": 529,
		"./mr": 530,
		"./mr.js": 530,
		"./ms": 532,
		"./ms-my": 531,
		"./ms-my.js": 531,
		"./ms.js": 532,
		"./my": 533,
		"./my.js": 533,
		"./nb": 534,
		"./nb.js": 534,
		"./ne": 535,
		"./ne.js": 535,
		"./nl": 537,
		"./nl-be": 536,
		"./nl-be.js": 536,
		"./nl.js": 537,
		"./nn": 538,
		"./nn.js": 538,
		"./pa-in": 539,
		"./pa-in.js": 539,
		"./pl": 540,
		"./pl.js": 540,
		"./pt": 542,
		"./pt-br": 541,
		"./pt-br.js": 541,
		"./pt.js": 542,
		"./ro": 543,
		"./ro.js": 543,
		"./ru": 544,
		"./ru.js": 544,
		"./sd": 545,
		"./sd.js": 545,
		"./se": 546,
		"./se.js": 546,
		"./si": 547,
		"./si.js": 547,
		"./sk": 548,
		"./sk.js": 548,
		"./sl": 549,
		"./sl.js": 549,
		"./sq": 550,
		"./sq.js": 550,
		"./sr": 552,
		"./sr-cyrl": 551,
		"./sr-cyrl.js": 551,
		"./sr.js": 552,
		"./ss": 553,
		"./ss.js": 553,
		"./sv": 554,
		"./sv.js": 554,
		"./sw": 555,
		"./sw.js": 555,
		"./ta": 556,
		"./ta.js": 556,
		"./te": 557,
		"./te.js": 557,
		"./tet": 558,
		"./tet.js": 558,
		"./th": 559,
		"./th.js": 559,
		"./tl-ph": 560,
		"./tl-ph.js": 560,
		"./tlh": 561,
		"./tlh.js": 561,
		"./tr": 562,
		"./tr.js": 562,
		"./tzl": 563,
		"./tzl.js": 563,
		"./tzm": 565,
		"./tzm-latn": 564,
		"./tzm-latn.js": 564,
		"./tzm.js": 565,
		"./uk": 566,
		"./uk.js": 566,
		"./ur": 567,
		"./ur.js": 567,
		"./uz": 569,
		"./uz-latn": 568,
		"./uz-latn.js": 568,
		"./uz.js": 569,
		"./vi": 570,
		"./vi.js": 570,
		"./x-pseudo": 571,
		"./x-pseudo.js": 571,
		"./yo": 572,
		"./yo.js": 572,
		"./zh-cn": 573,
		"./zh-cn.js": 573,
		"./zh-hk": 574,
		"./zh-hk.js": 574,
		"./zh-tw": 575,
		"./zh-tw.js": 575
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 986;


/***/ }),

/***/ 998:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(621),
	  /* template */
	  __webpack_require__(1484),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 999:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(808),
	  /* template */
	  __webpack_require__(1454),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1000:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(809),
	  /* template */
	  __webpack_require__(1378),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1001:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(935)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(810),
	  /* template */
	  __webpack_require__(1473),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1002:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(811),
	  /* template */
	  __webpack_require__(1376),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1003:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(898)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(812),
	  /* template */
	  __webpack_require__(1278),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1004:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(1269),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1006:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(1373),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1007:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(623),
	  /* template */
	  __webpack_require__(1414),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1008:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(915)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(624),
	  /* template */
	  __webpack_require__(1390),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1269:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.$parent.isAdminPage(_vm.$route.path)) ? _c('aside', {
	    staticClass: "aside-menu"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "nav nav-tabs",
	    attrs: {
	      "role": "tablist"
	    }
	  }, [_c('li', {
	    staticClass: "nav-item"
	  }, [_c('a', {
	    staticClass: "nav-link active",
	    attrs: {
	      "data-toggle": "tab",
	      "href": "#timeline",
	      "role": "tab"
	    }
	  }, [_c('i', {
	    staticClass: "icon-list"
	  })])]), _vm._v(" "), _c('li', {
	    staticClass: "nav-item"
	  }, [_c('a', {
	    staticClass: "nav-link",
	    attrs: {
	      "data-toggle": "tab",
	      "href": "#messages",
	      "role": "tab"
	    }
	  }, [_c('i', {
	    staticClass: "icon-speech"
	  })])]), _vm._v(" "), _c('li', {
	    staticClass: "nav-item"
	  }, [_c('a', {
	    staticClass: "nav-link",
	    attrs: {
	      "data-toggle": "tab",
	      "href": "#settings",
	      "role": "tab"
	    }
	  }, [_c('i', {
	    staticClass: "icon-settings"
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active",
	    attrs: {
	      "id": "timeline",
	      "role": "tabpanel"
	    }
	  }, [_c('div', {
	    staticClass: "callout m-0 py-h text-muted text-xs-center bg-faded text-uppercase"
	  }, [_c('small', [_c('b', [_vm._v("Today")])])]), _vm._v(" "), _c('hr', {
	    staticClass: "transparent mx-1 my-0"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "callout callout-warning m-0 py-1"
	  }, [_c('div', {
	    staticClass: "avatar float-xs-right"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/7.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', [_vm._v("Meeting with\n                    "), _c('strong', [_vm._v("Lucas")])]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted mr-1"
	  }, [_c('i', {
	    staticClass: "icon-calendar"
	  }), _vm._v("  1 - 3pm")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_c('i', {
	    staticClass: "icon-location-pin"
	  }), _vm._v("  Palo Alto, CA")])]), _vm._v(" "), _c('hr', {
	    staticClass: "mx-1 my-0"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "callout callout-info m-0 py-1"
	  }, [_c('div', {
	    staticClass: "avatar float-xs-right"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/4.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', [_vm._v("Skype with\n                    "), _c('strong', [_vm._v("Megan")])]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted mr-1"
	  }, [_c('i', {
	    staticClass: "icon-calendar"
	  }), _vm._v("  4 - 5pm")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_c('i', {
	    staticClass: "icon-social-skype"
	  }), _vm._v("  On-line")])]), _vm._v(" "), _c('hr', {
	    staticClass: "transparent mx-1 my-0"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "callout m-0 py-h text-muted text-xs-center bg-faded text-uppercase"
	  }, [_c('small', [_c('b', [_vm._v("Tomorrow")])])]), _vm._v(" "), _c('hr', {
	    staticClass: "transparent mx-1 my-0"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "callout callout-danger m-0 py-1"
	  }, [_c('div', [_vm._v("New UI Project -\n                    "), _c('strong', [_vm._v("deadline")])]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted mr-1"
	  }, [_c('i', {
	    staticClass: "icon-calendar"
	  }), _vm._v("  10 - 11pm")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_c('i', {
	    staticClass: "icon-home"
	  }), _vm._v("  creativeLabs HQ")]), _vm._v(" "), _c('div', {
	    staticClass: "avatars-stack mt-h"
	  }, [_c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/2.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/3.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/4.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/5.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/6.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })])])]), _vm._v(" "), _c('hr', {
	    staticClass: "mx-1 my-0"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "callout callout-success m-0 py-1"
	  }, [_c('div', [_c('strong', [_vm._v("#10 Startups.Garden")]), _vm._v("Meetup")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted mr-1"
	  }, [_c('i', {
	    staticClass: "icon-calendar"
	  }), _vm._v("  1 - 3pm")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_c('i', {
	    staticClass: "icon-location-pin"
	  }), _vm._v("  Palo Alto, CA")])]), _vm._v(" "), _c('hr', {
	    staticClass: "mx-1 my-0"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "callout callout-primary m-0 py-1"
	  }, [_c('div', [_c('strong', [_vm._v("Team meeting")])]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted mr-1"
	  }, [_c('i', {
	    staticClass: "icon-calendar"
	  }), _vm._v("  4 - 6pm")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_c('i', {
	    staticClass: "icon-home"
	  }), _vm._v("  creativeLabs HQ")]), _vm._v(" "), _c('div', {
	    staticClass: "avatars-stack mt-h"
	  }, [_c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/2.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/3.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/4.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/5.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/6.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/7.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/8.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })])])]), _vm._v(" "), _c('hr', {
	    staticClass: "mx-1 my-0"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane p-1",
	    attrs: {
	      "id": "messages",
	      "role": "tabpanel"
	    }
	  }, [_c('div', {
	    staticClass: "message"
	  }, [_c('div', {
	    staticClass: "py-1 pb-3 mr-1 float-xs-left"
	  }, [_c('div', {
	    staticClass: "avatar"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/7.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "avatar-status tag-success"
	  })])]), _vm._v(" "), _c('div', [_c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted float-xs-right mt-q"
	  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
	    staticClass: "text-truncate font-weight-bold"
	  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "message"
	  }, [_c('div', {
	    staticClass: "py-1 pb-3 mr-1 float-xs-left"
	  }, [_c('div', {
	    staticClass: "avatar"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/7.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "avatar-status tag-success"
	  })])]), _vm._v(" "), _c('div', [_c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted float-xs-right mt-q"
	  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
	    staticClass: "text-truncate font-weight-bold"
	  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "message"
	  }, [_c('div', {
	    staticClass: "py-1 pb-3 mr-1 float-xs-left"
	  }, [_c('div', {
	    staticClass: "avatar"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/7.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "avatar-status tag-success"
	  })])]), _vm._v(" "), _c('div', [_c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted float-xs-right mt-q"
	  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
	    staticClass: "text-truncate font-weight-bold"
	  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "message"
	  }, [_c('div', {
	    staticClass: "py-1 pb-3 mr-1 float-xs-left"
	  }, [_c('div', {
	    staticClass: "avatar"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/7.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "avatar-status tag-success"
	  })])]), _vm._v(" "), _c('div', [_c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted float-xs-right mt-q"
	  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
	    staticClass: "text-truncate font-weight-bold"
	  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "message"
	  }, [_c('div', {
	    staticClass: "py-1 pb-3 mr-1 float-xs-left"
	  }, [_c('div', {
	    staticClass: "avatar"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/7.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "avatar-status tag-success"
	  })])]), _vm._v(" "), _c('div', [_c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted float-xs-right mt-q"
	  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
	    staticClass: "text-truncate font-weight-bold"
	  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])])]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane p-1",
	    attrs: {
	      "id": "settings",
	      "role": "tabpanel"
	    }
	  }, [_c('h6', [_vm._v("Settings")]), _vm._v(" "), _c('div', {
	    staticClass: "aside-options"
	  }, [_c('div', {
	    staticClass: "clearfix mt-2"
	  }, [_c('small', [_c('b', [_vm._v("Option 1")])]), _vm._v(" "), _c('label', {
	    staticClass: "switch switch-text switch-pill switch-success switch-sm float-xs-right"
	  }, [_c('input', {
	    staticClass: "switch-input",
	    attrs: {
	      "type": "checkbox",
	      "checked": ""
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "switch-label",
	    attrs: {
	      "data-on": "On",
	      "data-off": "Off"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "switch-handle"
	  })])]), _vm._v(" "), _c('div', [_c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "aside-options"
	  }, [_c('div', {
	    staticClass: "clearfix mt-1"
	  }, [_c('small', [_c('b', [_vm._v("Option 2")])]), _vm._v(" "), _c('label', {
	    staticClass: "switch switch-text switch-pill switch-success switch-sm float-xs-right"
	  }, [_c('input', {
	    staticClass: "switch-input",
	    attrs: {
	      "type": "checkbox"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "switch-label",
	    attrs: {
	      "data-on": "On",
	      "data-off": "Off"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "switch-handle"
	  })])]), _vm._v(" "), _c('div', [_c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "aside-options"
	  }, [_c('div', {
	    staticClass: "clearfix mt-1"
	  }, [_c('small', [_c('b', [_vm._v("Option 3")])]), _vm._v(" "), _c('label', {
	    staticClass: "switch switch-text switch-pill switch-success switch-sm float-xs-right"
	  }, [_c('input', {
	    staticClass: "switch-input",
	    attrs: {
	      "type": "checkbox"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "switch-label",
	    attrs: {
	      "data-on": "On",
	      "data-off": "Off"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "switch-handle"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "aside-options"
	  }, [_c('div', {
	    staticClass: "clearfix mt-1"
	  }, [_c('small', [_c('b', [_vm._v("Option 4")])]), _vm._v(" "), _c('label', {
	    staticClass: "switch switch-text switch-pill switch-success switch-sm float-xs-right"
	  }, [_c('input', {
	    staticClass: "switch-input",
	    attrs: {
	      "type": "checkbox",
	      "checked": ""
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "switch-label",
	    attrs: {
	      "data-on": "On",
	      "data-off": "Off"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "switch-handle"
	  })])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("System Utilization")]), _vm._v(" "), _c('div', {
	    staticClass: "text-uppercase mb-q mt-2"
	  }, [_c('small', [_c('b', [_vm._v("CPU Usage")])])]), _vm._v(" "), _c('progress', {
	    staticClass: "progress progress-xs progress-info m-0",
	    attrs: {
	      "value": "25",
	      "max": "100"
	    }
	  }, [_vm._v("25%")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("348 Processes. 1/4 Cores.")]), _vm._v(" "), _c('div', {
	    staticClass: "text-uppercase mb-q mt-h"
	  }, [_c('small', [_c('b', [_vm._v("Memory Usage")])])]), _vm._v(" "), _c('progress', {
	    staticClass: "progress progress-xs progress-warning m-0",
	    attrs: {
	      "value": "70",
	      "max": "100"
	    }
	  }, [_vm._v("70%")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("11444GB/16384MB")]), _vm._v(" "), _c('div', {
	    staticClass: "text-uppercase mb-q mt-h"
	  }, [_c('small', [_c('b', [_vm._v("SSD 1 Usage")])])]), _vm._v(" "), _c('progress', {
	    staticClass: "progress progress-xs progress-danger m-0",
	    attrs: {
	      "value": "95",
	      "max": "100"
	    }
	  }, [_vm._v("95%")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("243GB/256GB")]), _vm._v(" "), _c('div', {
	    staticClass: "text-uppercase mb-q mt-h"
	  }, [_c('small', [_c('b', [_vm._v("SSD 2 Usage")])])]), _vm._v(" "), _c('progress', {
	    staticClass: "progress progress-xs progress-success m-0",
	    attrs: {
	      "value": "10",
	      "max": "100"
	    }
	  }, [_vm._v("10%")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("25GB/256GB")])])])
	}]}

/***/ }),

/***/ 1278:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vue-street-view-pano-container"
	  }, [_c('div', {
	    ref: "vue-street-view-pano",
	    staticClass: "vue-street-view-pano"
	  }), _vm._v(" "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 1373:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.$parent.isAdminPage(_vm.$route.path)) ? _c('footer', {
	    staticClass: "footer"
	  }) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 1376:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', [_c('span', {
	    domProps: {
	      "textContent": _vm._s(_vm.label)
	    }
	  }), _vm._v(" "), _c('input', {
	    ref: "input",
	    class: _vm.className,
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.placeholder
	    }
	  })])
	},staticRenderFns: []}

/***/ }),

/***/ 1378:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    ref: "flyaway"
	  }, [_vm._t("default", [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.content)
	    }
	  })])], 2)])
	},staticRenderFns: []}

/***/ }),

/***/ 1390:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.$parent.isAdminPage(_vm.$route.path, _vm.$route.name)) ? _c('div', {
	    staticClass: "sidebar"
	  }, [(_vm.userinfo.user_level === 'admin') ? _c('nav', {
	    staticClass: "sidebar-nav"
	  }, [_c('ul', {
	    staticClass: "nav"
	  }, [_c('li', {
	    staticClass: "nav-item"
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/dashboard",
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "icon-speedometer"
	  }), _vm._v(" Dashboard\n                ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "nav-item nav-dropdown"
	  }, [_vm._m(0), _vm._v(" "), _c('ul', {
	    staticClass: "nav-dropdown-items nav-dropdown-items-left"
	  }, [_c('li', {
	    staticClass: "nav-item"
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/company',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-suitcase"
	  }), _vm._v(" View All\n                        ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "nav-item"
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/company/add'
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  }), _vm._v(" Add\n                        ")])], 1)])]), _vm._v(" "), _c('li', {
	    staticClass: "nav-item nav-dropdown"
	  }, [_vm._m(1), _vm._v(" "), _c('ul', {
	    staticClass: "nav-dropdown-items nav-dropdown-items-left"
	  }, [_c('li', {
	    staticClass: "nav-item"
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/usersadmin',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-users"
	  }), _vm._v(" View All\n                        ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "nav-item"
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/usersadmin/add'
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-plus"
	  }), _vm._v(" Add\n                        ")])], 1)])])])]) : _c('nav', {
	    staticClass: "sidebar-nav"
	  }, [_c('ul', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.current_top_menu === 'retail execution'),
	      expression: "current_top_menu === 'retail execution'"
	    }],
	    staticClass: "nav"
	  }, [(_vm.is_master === true || (_vm.is_manager === true || _vm.is_client === true)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(dashboard)')
	    }
	  }, [_c('router-link', {
	    class: ['nav-link'],
	    attrs: {
	      "to": {
	        path: '/retailer-execution',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chart-bar"
	  }), _vm._v("Activities\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.is_manager === true || _vm.is_client === true)) ? _c('li', {
	    staticClass: "nav-item nav-dropdown",
	    class: {
	      'open': _vm.active_actions
	    }
	  }, [_vm._m(2), _vm._v(" "), _c('ul', {
	    staticClass: "nav-dropdown-items",
	    class: {
	      'nav-dropdown-items-left': !_vm.active_actions, 'dbimportant': _vm.active_actions
	    }
	  }, [(_vm.is_master === true || (_vm.permissions.indexOf('136') >= 0 && _vm.features.indexOf('visit') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(visits)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/visits',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-street-view"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-title",
	    attrs: {
	      "title": "Visits"
	    }
	  }, [_vm._v("Visits")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('136') >= 0 && _vm.features.indexOf('visit') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(visit-calendar)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/visit-calendar',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "far fa-calendar-alt"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-title",
	    attrs: {
	      "title": "Visit Calendar"
	    }
	  }, [_vm._v("Calendar")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.is_manager === true || _vm.is_client === true)) ? _c('li', {
	    staticClass: "nav-item nav-dropdown",
	    class: {
	      'open': _vm.active_reports
	    }
	  }, [_vm._m(3), _vm._v(" "), _c('ul', {
	    staticClass: "nav-dropdown-items",
	    class: {
	      'nav-dropdown-items-left': !_vm.active_reports, 'dbimportant': _vm.active_reports
	    }
	  }, [(_vm.is_master === true || ((_vm.features.indexOf('retailer_reports') >= 0) && _vm.is_client === false)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(visit-report2)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/visit-report2',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-shopping-cart"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-title",
	    attrs: {
	      "title": "Retailer Report"
	    }
	  }, [_vm._v("Visit Report")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.features.indexOf('retailer_reports') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(photo-gallery-report)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/photo-gallery-report',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-images"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-title",
	    attrs: {
	      "title": "Retailer Report"
	    }
	  }, [_vm._v("Photo Gallery Report")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.features.indexOf('store_audit') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(store-audit-report)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/store-audit-report'
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "far fa-calendar-check"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-title",
	    attrs: {
	      "title": "Store Audit "
	    }
	  }, [_vm._v("Store Audit ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('140') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(task-report)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/task-report'
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-tasks"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-title",
	    attrs: {
	      "title": "Task Report"
	    }
	  }, [_vm._v("Task Report")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('140') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(historical-taskreport)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/historical-taskreport'
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-history"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-title",
	    attrs: {
	      "title": "Historical Report"
	    }
	  }, [_vm._v("Historical Report")])])], 1) : _vm._e(), _vm._v(" "), _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(no-visit-location-report)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/no-visit-location-report?page=1'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-thumbtack"
	  }), _vm._v(" Unplanned Visit\n                        ")])], 1), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('140') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(uncompleted-store-visits)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/uncompleted-store-visits',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "far fa-calendar-times"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-title",
	    attrs: {
	      "title": "Uncompleted Visits"
	    }
	  }, [_vm._v("Uncompleted Visits")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_manager === true) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(master-visit-report)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/master-visit-report'
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-list"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-title",
	    attrs: {
	      "title": "Master Report"
	    }
	  }, [_vm._v("Master Report")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_manager === true) ? _c('li', {
	    staticClass: "nav-item nav-dropdown",
	    class: {
	      'open': _vm.active_locations
	    }
	  }, [_vm._m(4), _vm._v(" "), _c('ul', {
	    staticClass: "nav-dropdown-items",
	    class: {
	      'nav-dropdown-items-left': !_vm.active_locations, 'dbimportant': _vm.active_locations
	    }
	  }, [(_vm.is_master === true || (_vm.permissions.indexOf('12') >= 0 && _vm.features.indexOf('locations') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(locations)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/locations',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-list"
	  }), _vm._v(" Locations\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('12') >= 0 && _vm.features.indexOf('location_map') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(location-map)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/location-map'
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-map-marker-alt"
	  }), _vm._v(" Location Map\n                        ")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.is_manager === true)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(merchandisers)')
	    }
	  }, [_c('router-link', {
	    class: ['nav-link', {
	      'active': _vm.isActiveMenu(_vm.merchandiser_paths)
	    }],
	    attrs: {
	      "to": {
	        path: '/merchandisers',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-user-tie"
	  }), _vm._v(" Merchandisers\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(tasks)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/tasks',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-list-ol"
	  }), _vm._v(" Tasks\n                ")])], 1) : _vm._e()]), _vm._v(" "), _c('ul', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.current_top_menu === 'stock-management-dashboard'),
	      expression: "current_top_menu === 'stock-management-dashboard'"
	    }],
	    staticClass: "nav"
	  }, [(_vm.is_master === true || (_vm.is_manager === true || _vm.is_client === true && (_vm.plan === 2 || _vm.plan === 3 || _vm.plan === 4))) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(dashboard)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/stock-management-dashboard",
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chart-bar"
	  }), _vm._v(" Activities\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.is_manager === true || _vm.is_client === true && (_vm.plan === 2 || _vm.plan === 3 || _vm.plan === 4))) ? _c('li', {
	    staticClass: "nav-item nav-dropdown",
	    class: {
	      'open': _vm.active_actions
	    }
	  }, [_vm._m(5), _vm._v(" "), _c('ul', {
	    staticClass: "nav-dropdown-items",
	    class: {
	      'nav-dropdown-items-left': !_vm.active_actions, 'dbimportant': _vm.active_actions
	    }
	  }, [(_vm.is_master === true || (_vm.permissions.indexOf('136') >= 0 && _vm.features.indexOf('visit') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(visits)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/visits',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-street-view"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-title",
	    attrs: {
	      "title": "Visits"
	    }
	  }, [_vm._v("Visits")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('136') >= 0 && _vm.features.indexOf('visit') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(visit-calendar)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/visit-calendar',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "far fa-calendar-alt"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-title",
	    attrs: {
	      "title": "Visit Calendar"
	    }
	  }, [_vm._v("Calendar")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_manager === true || _vm.is_client === true && (_vm.plan === 2 || _vm.plan === 3 || _vm.plan === 4)) ? _c('li', {
	    staticClass: "nav-item nav-dropdown",
	    class: {
	      'open': _vm.active_reports
	    }
	  }, [_vm._m(6), _vm._v(" "), _c('ul', {
	    staticClass: "nav-dropdown-items",
	    class: {
	      'nav-dropdown-items-left': !_vm.active_reports, 'dbimportant': _vm.active_reports
	    }
	  }, [(_vm.is_master === true || ((_vm.features.indexOf('retailer_reports') >= 0) && _vm.is_client === false)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(visit-report2)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/visit-report2',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-shopping-cart"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-title",
	    attrs: {
	      "title": "Retailer Report"
	    }
	  }, [_vm._v("Visit Report")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true || _vm.is_client === true) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(stock-take-reports)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/stock-take-reports',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-box"
	  }), _vm._v(" Stock Take Report\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true || _vm.is_client === true) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(stock-take-photo-reports)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/stock-take-photo-reports',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-images"
	  }), _vm._v(" Photo Gallery Report\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && (_vm.plan === 3 || _vm.plan === 4))) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(planogram-visit-reports)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/planogram-visit-reports',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "far fa-eye"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-title",
	    attrs: {
	      "title": "Planogram Report"
	    }
	  }, [_vm._v("Planogram Report")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && (_vm.plan === 3 || _vm.plan === 4))) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(oos-report)')
	    }
	  }, [(_vm.is_master === true || _vm.features.indexOf('sales') >= 0) ? _c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/oos-report?page=1'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "far fa-times-circle"
	  }), _vm._v(" OOS Report\n                        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && _vm.plan === 4)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(stock-take-management-reports)')
	    }
	  }, [(_vm.is_master === true || _vm.features.indexOf('promoters') >= 0) ? _c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/stock-take-management-reports?page=1'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-user"
	  }), _vm._v(" Promoter Stock Take\n                        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && _vm.plan === 4)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(stock-request-management-reports)')
	    }
	  }, [(_vm.is_master === true || _vm.features.indexOf('promoters') >= 0) ? _c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/stock-request-management-reports?page=1'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "far fa-plus-square"
	  }), _vm._v(" Stock Request\n                        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && _vm.plan === 4)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(stock-receipt-management-reports)')
	    }
	  }, [(_vm.is_master === true || _vm.features.indexOf('promoters') >= 0) ? _c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/stock-receipt-management-reports?page=1'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-clipboard-check"
	  }), _vm._v(" Stock Receipt\n                        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && _vm.plan === 4)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(stock-transfer-management-reports)')
	    }
	  }, [(_vm.is_master === true || _vm.features.indexOf('promoters') >= 0) ? _c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/stock-transfer-management-reports?page=1'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-exchange-alt"
	  }), _vm._v(" Stock Transfer\n                        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && _vm.plan === 4)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(stock-receipt-erp-management-reports)')
	    }
	  }, [(_vm.is_master === true || _vm.features.indexOf('promoters') >= 0) ? _c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/stock-receipt-erp-management-reports?page=1'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-clipboard-check"
	  }), _vm._v(" Stock Receipt ERP\n                        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.is_manager === true && _vm.plan === 4)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(discrepancy-report)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/discrepancy-report'
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-balance-scale"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-title",
	    attrs: {
	      "title": "Discrepancy Report"
	    }
	  }, [_vm._v("Discrepancy Report")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true) ? _c('li', {
	    staticClass: "nav-item nav-dropdown",
	    class: {
	      'open': _vm.active_locations
	    }
	  }, [_vm._m(7), _vm._v(" "), _c('ul', {
	    staticClass: "nav-dropdown-items",
	    class: {
	      'nav-dropdown-items-left': !_vm.active_locations, 'dbimportant': _vm.active_locations
	    }
	  }, [(_vm.is_master === true || (_vm.permissions.indexOf('12') >= 0 && _vm.features.indexOf('locations') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(locations)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/locations',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-list"
	  }), _vm._v(" Locations\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('12') >= 0 && _vm.features.indexOf('location_map') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(location-map)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/location-map'
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-map-marker-alt"
	  }), _vm._v(" Location Map\n                        ")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(merchandisers)')
	    }
	  }, [_c('router-link', {
	    class: ['nav-link', {
	      'active': _vm.isActiveMenu(_vm.merchandiser_paths)
	    }],
	    attrs: {
	      "to": {
	        path: '/merchandisers',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-user-tie"
	  }), _vm._v(" Merchandisers\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(tasks)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/tasks',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-list-ol"
	  }), _vm._v(" Tasks\n                ")])], 1) : _vm._e()]), _vm._v(" "), _c('ul', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.current_top_menu === 'sales dashboard'),
	      expression: "current_top_menu === 'sales dashboard'"
	    }],
	    staticClass: "nav"
	  }, [(_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && _vm.plan === 4)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(dashboard)')
	    }
	  }, [_c('router-link', {
	    class: ['nav-link'],
	    attrs: {
	      "to": {
	        path: '/sales-dashboard',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-chart-bar"
	  }), _vm._v("Activities\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.is_manager === true && _vm.plan === 4)) ? _c('li', {
	    staticClass: "nav-item nav-dropdown",
	    class: {
	      'open': _vm.active_actions
	    }
	  }, [_vm._m(8), _vm._v(" "), _c('ul', {
	    staticClass: "nav-dropdown-items",
	    class: {
	      'nav-dropdown-items-left': !_vm.active_actions, 'dbimportant': _vm.active_actions
	    }
	  }, [(_vm.is_master === true || (_vm.permissions.indexOf('156') >= 0 && _vm.features.indexOf('promoters') >= 0)) ? _c('li', {
	    class: ['nav-item', 'link-master-data', {
	      'active-menu': _vm.isActiveMenu('(promoter-rosters)')
	    }]
	  }, [_c('router-link', {
	    class: ['nav-link', {
	      'active': _vm.isActiveMenu(_vm.promoter_roster_path)
	    }],
	    attrs: {
	      "to": {
	        path: '/promoter-rosters',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-street-view"
	  }), _vm._v(" Roster\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('156') >= 0 && _vm.features.indexOf('promoters') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(promoter-calendar)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/promoter-calendar',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "far fa-calendar-alt"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-title",
	    attrs: {
	      "title": "Roster Calendar"
	    }
	  }, [_vm._v("Roster Calendar")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && _vm.plan === 4)) ? _c('li', {
	    staticClass: "nav-item nav-dropdown",
	    class: {
	      'open': _vm.active_reports
	    }
	  }, [_vm._m(9), _vm._v(" "), _c('ul', {
	    staticClass: "nav-dropdown-items",
	    class: {
	      'nav-dropdown-items-left': !_vm.active_reports, 'dbimportant': _vm.active_reports
	    }
	  }, [(_vm.is_master === true || (_vm.permissions.indexOf('156') >= 0 && _vm.features.indexOf('promoters') >= 0)) ? _c('li', {
	    class: ['nav-item', 'link-master-data', {
	      'active-menu': _vm.isActiveMenu('(promoter-roster-report)')
	    }]
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/promoter-roster-report',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-user-clock"
	  }), _vm._v(" Attendance\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('156') >= 0 && _vm.features.indexOf('promoters') >= 0)) ? _c('li', {
	    class: ['nav-item', 'link-master-data', {
	      'active-menu': _vm.isActiveMenu('(non-clocked-employee-reports)')
	    }]
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/non-clocked-employee-reports',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-exclamation-circle"
	  }), _vm._v(" Non Clocked\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('158') >= 0 && _vm.features.indexOf('sales') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(salesreport)')
	    }
	  }, [(_vm.is_master === true || _vm.features.indexOf('sales') >= 0) ? _c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/salesreport?page=1'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-file-invoice-dollar"
	  }), _vm._v("Sales Report\n                        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.is_client !== true) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(commission-report)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/commission-report',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-piggy-bank"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-title",
	    attrs: {
	      "title": "Commission Report"
	    }
	  }, [_vm._v("Commission Report")])])], 1) : _vm._e(), _vm._v(" "), (_vm.sampling === 1 && _vm.is_client !== true) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(sampling-reports)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/sampling-reports',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-piggy-bank"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-title",
	    attrs: {
	      "title": "Commission Report"
	    }
	  }, [_vm._v("Sampling Report")])])], 1) : _vm._e(), _vm._v(" "), (_vm.is_client !== true) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(customers)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/customers',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-users"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "nav-title",
	    attrs: {
	      "title": "CRM"
	    }
	  }, [_vm._v("CRM")])])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true) ? _c('li', {
	    staticClass: "nav-item nav-dropdown",
	    class: {
	      'open': _vm.active_locations
	    }
	  }, [_vm._m(10), _vm._v(" "), _c('ul', {
	    staticClass: "nav-dropdown-items",
	    class: {
	      'nav-dropdown-items-left': !_vm.active_locations, 'dbimportant': _vm.active_locations
	    }
	  }, [(_vm.is_master === true || (_vm.permissions.indexOf('12') >= 0 && _vm.features.indexOf('locations') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(locations)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/locations',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-list"
	  }), _vm._v(" Locations\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('12') >= 0 && _vm.features.indexOf('location_map') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(location-map)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/location-map'
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-map-marker-alt"
	  }), _vm._v(" Location Map\n                        ")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true) ? _c('li', {
	    class: ['nav-item', 'link-master-data', {
	      'active-menu': _vm.isActiveMenu('(promoters)')
	    }]
	  }, [_c('router-link', {
	    class: ['nav-link', {
	      'active': _vm.isActiveMenu(_vm.promoter_path)
	    }],
	    attrs: {
	      "to": {
	        path: '/promoters',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-user-tie"
	  }), _vm._v(" Promoters\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.is_manager === true && ((_vm.permissions.indexOf('168') >= 0 || _vm.permissions.indexOf('172') >= 0) &&
	    _vm.features.indexOf('sales') >= 0 && _vm.userinfo.client_id === null))) ? _c('li', {
	    staticClass: "nav-item nav-dropdown",
	    class: {
	      'open': _vm.active_sales_settings
	    }
	  }, [_vm._m(11), _vm._v(" "), _c('ul', {
	    staticClass: "nav-dropdown-items ",
	    class: {
	      'nav-dropdown-items-left': !_vm.active_sales_settings, 'dbimportant': _vm.active_sales_settings
	    },
	    staticStyle: {
	      "top": "auto",
	      "bottom": "0"
	    }
	  }, [(_vm.is_master === true || (_vm.userinfo.client_id === null && _vm.permissions.indexOf('168') >= 0 && _vm.features.indexOf('sales') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(sales-target-location)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/sales-target-location?page=1'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-map-pin"
	  }), _vm._v(" Per Location\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.userinfo.client_id === null && _vm.permissions.indexOf('172') >= 0 && _vm.features.indexOf('sales') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(sales-target-promoter)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/sales-target-promoter?page=1'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-user-tag"
	  }), _vm._v(" Per Promoter\n                        ")])], 1) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('ul', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.current_top_menu === 'settings' && _vm.is_manager === true),
	      expression: "current_top_menu === 'settings' && is_manager === true"
	    }],
	    staticClass: "nav"
	  }, [(_vm.is_master === true || _vm.is_manager === true) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(dashboard)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/settings",
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-cogs"
	  }), _vm._v(" Company Settings\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true) ? _c('li', {
	    staticClass: "nav-item nav-dropdown",
	    class: {
	      'open': _vm.active_manage_users
	    }
	  }, [_vm._m(12), _vm._v(" "), _c('ul', {
	    staticClass: "nav-dropdown-items",
	    class: {
	      'nav-dropdown-items-left': !_vm.active_manage_users, 'dbimportant': _vm.active_manage_users
	    }
	  }, [(_vm.is_master === true || _vm.permissions.indexOf('1') >= 0) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(/users)')
	    }
	  }, [_c('router-link', {
	    class: ['nav-link', {
	      'active': _vm.isActiveMenu(_vm.active_company_settings)
	    }],
	    attrs: {
	      "to": {
	        path: '/users',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-users"
	  }), _vm._v(" Users\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.permissions.indexOf('1') >= 0) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(clientusers)')
	    }
	  }, [_c('router-link', {
	    class: ['nav-link', {
	      'active': _vm.isActiveMenu(_vm.clientusers_path)
	    }],
	    attrs: {
	      "to": {
	        path: '/clientusers',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-user-lock"
	  }), _vm._v(" Clients\n                        ")])], 1) : _vm._e(), _vm._v(" "), ((_vm.is_master === true || _vm.permissions.indexOf('1') >= 0) && _vm.is_supervisor === false) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(assign-supervisor)')
	    }
	  }, [_c('router-link', {
	    class: ['nav-link', {
	      'active': _vm.isActiveMenu(_vm.assignsupervisor_path)
	    }],
	    attrs: {
	      "to": {
	        path: '/assign-supervisor',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-user-lock"
	  }), _vm._v(" Assign Supervisor\n                        ")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.is_manager === true) ? _c('li', {
	    staticClass: "nav-item nav-dropdown",
	    class: {
	      'open': _vm.active_location_settings
	    }
	  }, [_vm._m(13), _vm._v(" "), _c('ul', {
	    staticClass: "nav-dropdown-items",
	    class: {
	      'nav-dropdown-items-left': !_vm.active_location_settings, 'dbimportant': _vm.active_location_settings
	    }
	  }, [(_vm.is_master === true || (_vm.permissions.indexOf('16') >= 0 && _vm.features.indexOf('clients') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(clients)')
	    }
	  }, [_c('router-link', {
	    class: ['nav-link', {
	      'active': _vm.isActiveMenu(_vm.client_paths)
	    }],
	    attrs: {
	      "to": {
	        path: '/clients',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "icon-user-follow"
	  }), _vm._v(" Clients\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('84') >= 0 && _vm.features.indexOf('retailers') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(retailers)')
	    }
	  }, [_c('router-link', {
	    class: ['nav-link', {
	      'active': _vm.isActiveMenu(_vm.retailers_paths)
	    }],
	    attrs: {
	      "to": {
	        path: '/retailers',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "glyphicons glyphicons-industrial-zone"
	  }), _vm._v(" Retailers\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || _vm.permissions.indexOf('188') >= 0) ? _c('li', {
	    class: ['nav-item', 'link-master-data', {
	      'active-menu': _vm.isActiveMenu('(planograms)')
	    }]
	  }, [_c('router-link', {
	    class: ['nav-link', {
	      'active': _vm.isActiveMenu(_vm.planogram_path)
	    }],
	    attrs: {
	      "to": {
	        path: '/planograms',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-image"
	  }), _vm._v(" Planogram Pictures\n                        ")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.is_manager === true && (_vm.plan === 2 || _vm.plan === 3 || _vm.plan === 4))) ? _c('li', {
	    staticClass: "nav-item nav-dropdown",
	    class: {
	      'open': _vm.active_product_settings
	    }
	  }, [_vm._m(14), _vm._v(" "), _c('ul', {
	    staticClass: "nav-dropdown-items",
	    class: {
	      'nav-dropdown-items-left': !_vm.active_product_settings, 'dbimportant': _vm.active_product_settings
	    }
	  }, [(_vm.is_master === true || (_vm.permissions.indexOf('68') >= 0 && _vm.features.indexOf('product_packing') >= 0)) ? _c('li', {
	    class: ['nav-item', 'link-master-data', {
	      'active-menu': _vm.isActiveMenu('(product-packings)')
	    }, {
	      'open': _vm.isActiveMenu(_vm.productpacking_paths)
	    }]
	  }, [_c('router-link', {
	    class: ['nav-link', {
	      'active': _vm.isActiveMenu(_vm.productpacking_paths)
	    }],
	    attrs: {
	      "to": {
	        path: '/product-packings',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-box"
	  }), _vm._v(" Packings\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('8') >= 0 && _vm.features.indexOf('product_category') >= 0)) ? _c('li', {
	    class: ['nav-item', 'link-master-data', {
	      'active-menu': _vm.isActiveMenu('(product-categories)')
	    }, {
	      'open': _vm.isActiveMenu(_vm.productcategory_paths)
	    }]
	  }, [_c('router-link', {
	    class: ['nav-link', {
	      'active': _vm.isActiveMenu(_vm.productcategory_paths)
	    }],
	    attrs: {
	      "to": {
	        path: '/product-categories',
	        query: {
	          page: 1
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "icon-handbag"
	  }), _vm._v(" Categories\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('60') >= 0 && _vm.features.indexOf('product_brand') >= 0)) ? _c('li', {
	    class: ['nav-item', 'link-master-data', {
	      'active-menu': _vm.isActiveMenu('(product-brands)')
	    }, {
	      'open': _vm.isActiveMenu(_vm.productbrand_paths)
	    }]
	  }, [_c('router-link', {
	    class: ['nav-link', {
	      'active': _vm.isActiveMenu(_vm.productbrand_paths)
	    }],
	    attrs: {
	      "to": {
	        path: '/product-brands',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-shopping-bag"
	  }), _vm._v(" Brands\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('4') >= 0 && _vm.features.indexOf('products') >= 0)) ? _c('li', {
	    class: ['nav-item', 'link-master-data', {
	      'active-menu': _vm.isActiveMenu('(products)')
	    }, {
	      'open': _vm.isActiveMenu(_vm.product_paths)
	    }]
	  }, [_c('router-link', {
	    class: ['nav-link', {
	      'active': _vm.isActiveMenu(_vm.product_paths)
	    }],
	    attrs: {
	      "to": {
	        path: '/products',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "glyphicons glyphicons-shopping-cart"
	  }), _vm._v(" Products\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('108') >= 0 && _vm.features.indexOf('store_model') >= 0)) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(store-model)')
	    }
	  }, [_c('router-link', {
	    class: ['nav-link', {
	      'active': _vm.isActiveMenu(_vm.store_model_paths)
	    }],
	    attrs: {
	      "to": {
	        path: '/store-model',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-store"
	  }), _vm._v("Store Models\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('144') >= 0 && _vm.features.indexOf('price_lists') >= 0)) ? _c('li', {
	    class: ['nav-item', 'link-master-data', {
	      'active-menu': _vm.isActiveMenu('(price-lists)')
	    }, {
	      'open': _vm.isActiveMenu(_vm.pricelists_paths)
	    }]
	  }, [_c('router-link', {
	    class: ['nav-link', {
	      'active': _vm.isActiveMenu(_vm.pricelists_paths)
	    }],
	    attrs: {
	      "to": {
	        path: '/price-lists',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-comment-dollar"
	  }), _vm._v(" Price Lists\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || (_vm.permissions.indexOf('64') >= 0 && _vm.features.indexOf('product_mapping') >= 0)) ? _c('li', {
	    class: ['nav-item', 'link-master-data', {
	      'active-menu': _vm.isActiveMenu('(product-mapping-codes)')
	    }, {
	      'open': _vm.isActiveMenu(_vm.productmapping_paths)
	    }]
	  }, [_c('router-link', {
	    class: ['nav-link', {
	      'active': _vm.isActiveMenu(_vm.productmapping_paths)
	    }],
	    attrs: {
	      "to": {
	        path: '/product-mapping-codes',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-pencil-ruler"
	  }), _vm._v("Mapping\n                        ")])], 1) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('ul', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.current_top_menu === 'user profile'),
	      expression: "current_top_menu === 'user profile'"
	    }],
	    staticClass: "nav"
	  }, [_c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(dashboard)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/profile',
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  }), _vm._v(" Profile\n                ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(dashboard)')
	    }
	  }, [_c('a', {
	    staticClass: "nav-link",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.logout($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-lock"
	  }), _vm._v(" Logout")])])])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link nav-dropdown-toggle",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-exchange"
	  }), _vm._v("Company")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link nav-dropdown-toggle",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-exchange"
	  }), _vm._v("Users")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link nav-dropdown-toggle",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-calendar-plus"
	  }), _vm._v("Actions")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link nav-dropdown-toggle",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-chart-line"
	  }), _vm._v("Reports")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link nav-dropdown-toggle",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-map-marked-alt"
	  }), _vm._v("Locations")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link nav-dropdown-toggle",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-calendar-plus"
	  }), _vm._v("Actions")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link nav-dropdown-toggle",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-chart-line"
	  }), _vm._v("Reports")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link nav-dropdown-toggle",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-map-marked-alt"
	  }), _vm._v("Locations")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link nav-dropdown-toggle",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-calendar-plus"
	  }), _vm._v("Actions")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link nav-dropdown-toggle",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-chart-line"
	  }), _vm._v("Reports")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link nav-dropdown-toggle",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-map-marked-alt"
	  }), _vm._v("Locations")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link nav-dropdown-toggle",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-dollar-sign"
	  }), _vm._v("Sales Targets")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link nav-dropdown-toggle",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-users-cog"
	  }), _vm._v("Manage Users")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link nav-dropdown-toggle",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-sliders-h"
	  }), _vm._v("Location Settings")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link nav-dropdown-toggle",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-toolbox"
	  }), _vm._v("Product Settings")])
	}]}

/***/ }),

/***/ 1414:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.$parent.isAdminPage(_vm.$route.path, _vm.$route.name)) ? _c('header', {
	    staticClass: "navbar"
	  }, [_c('div', {
	    staticClass: "container-fluid"
	  }, [_c('button', {
	    staticClass: "navbar-toggler mobile-toggler hidden-lg-up",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("☰")]), _vm._v(" "), _c('router-link', {
	    staticClass: "navbar-brand",
	    staticStyle: {
	      "padding": "0",
	      "text-align": "center",
	      "background-image": "none"
	    },
	    attrs: {
	      "to": "/retailer-execution",
	      "exact": ""
	    }
	  }, [(!_vm.logo) ? _c('span', [_vm._v(_vm._s(_vm.company_name))]) : _c('img', {
	    staticClass: "logo",
	    attrs: {
	      "src": _vm.logo
	    }
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "nav navbar-nav hidden-md-down float-xs-left"
	  }, [_vm._m(0), _vm._v(" "), (_vm.is_master === true || (_vm.is_manager === true || _vm.is_client === true)) ? _c('li', {
	    staticClass: "nav-item",
	    staticStyle: {
	      "padding": "0 20px",
	      "padding-left": "40px"
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    class: {
	      'active ': _vm.is_active_menu('retail execution')
	    },
	    attrs: {
	      "to": {
	        path: '/retailer-execution',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_vm._v("\n                    Retail Execution\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && (_vm.company_plan === 2 || _vm.company_plan === 3 || _vm.company_plan === 4))) ? _c('li', {
	    staticClass: "nav-item",
	    staticStyle: {
	      "padding": "0 20px"
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    class: {
	      'active ': _vm.is_active_menu('stock-management-dashboard')
	    },
	    attrs: {
	      "to": "/stock-management-dashboard",
	      "exact": ""
	    }
	  }, [_vm._v("\n                      Stock Management\n                ")])], 1) : _vm._e(), _vm._v(" "), (_vm.is_master === true || ((_vm.is_manager === true || _vm.is_client === true) && _vm.company_plan === 4)) ? _c('li', {
	    staticClass: "nav-item",
	    staticStyle: {
	      "padding": "0 20px"
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    class: {
	      'active ': _vm.is_active_menu('sales dashboard')
	    },
	    attrs: {
	      "to": {
	        path: '/sales-dashboard',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_vm._v("\n                    Sales\n                ")])], 1) : _vm._e()]), _vm._v(" "), _c('ul', {
	    staticClass: "nav navbar-nav float-xs-right"
	  }, [_c('li', {
	    staticClass: "nav-item dropdown"
	  }, [(_vm.is_master === true || _vm.is_manager === true) ? _c('router-link', {
	    staticClass: "nav-link avatar",
	    staticStyle: {
	      "float": "left"
	    },
	    attrs: {
	      "to": {
	        path: '/settings',
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "icon-settings icons font-2xl",
	    staticStyle: {
	      "color": "#25bdad"
	    }
	  })]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu dropdown-menu-right"
	  }, [_c('router-link', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "to": {
	        path: '/profile',
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  }), _vm._v(" Profile\n                    ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "to": {
	        path: '/announcements/all',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-bullhorn"
	  }), _vm._v(" Announcements\n                    ")]), _vm._v(" "), (_vm.is_master === true || _vm.permissions.indexOf('1') >= 0) ? _c('router-link', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "to": {
	        path: '/settings',
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-wrench"
	  }), _vm._v(" Settings\n                    ")]) : _vm._e(), _vm._v(" "), _c('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.logout($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-lock"
	  }), _vm._v(" Logout")])], 1)], 1)])], 1)]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "nav-item",
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_c('a', {
	    staticClass: "nav-link navbar-toggler layout-toggler",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("☰")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link avatar",
	    staticStyle: {
	      "float": "left"
	    },
	    attrs: {
	      "data-toggle": "dropdown",
	      "href": "#",
	      "role": "button",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_c('i', {
	    staticClass: "icon-user icons font-2xl",
	    staticStyle: {
	      "color": "#25bdad"
	    }
	  })])
	}]}

/***/ }),

/***/ 1454:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('input', {
	    ref: "input",
	    attrs: {
	      "type": "text",
	      "placeholder": _vm.placeholder
	    },
	    domProps: {
	      "value": _vm.value
	    }
	  })
	},staticRenderFns: []}

/***/ }),

/***/ 1473:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vue-map-container"
	  }, [_c('div', {
	    ref: "vue-map",
	    staticClass: "vue-map"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "vue-map-hidden"
	  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 1484:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "calendar",
	    attrs: {
	      "id": "calendar"
	    }
	  })
	},staticRenderFns: []}

/***/ }),

/***/ 1555:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.74aeb33dcc23df4e34fc.js